import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {IBusinessPartner, IVehicle, IVehicleTypeInformation, Vehicle} from '@service-and-repairs/awpintegrationlib';
import {CosyService} from '../../cosy/cosy.service';
import {UserData} from '../../user/models/user-data';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  getVehicles(vin: string, user: UserData): Promise<IVehicle[]> {
    return new Promise((resolve, reject): void => {
      const userParameters = `?locale=${user.getLocale()}&country=${user.getB2XCountryCode()}`;
      const businessPartner: IBusinessPartner = user.getBusinessPartner();
      const dealerParameters: string = businessPartner
        ? `&distribution_partner_number=${businessPartner.getDistributionPartnerNumber()}&outlet_number=${businessPartner.getOutletNumber()}`
        : '';
      this.httpClient.get('/api/vehicle/v2/' + vin + userParameters + dealerParameters, {withCredentials: true})
        .subscribe({
          next: (response: any): void => {
            const vehicles: IVehicle[] = response.data.vehicles.map((rawVehicle: any): IVehicle => CosyService.addBasePathToCosyUrls(
              Vehicle.fromRawData(rawVehicle)
            ));
            resolve(vehicles);
          },
          error: (reason: any): void => reject(reason)
        });
    });
  }

  getVirtualVehicle(typeCode: string, user: UserData): Promise<IVehicle> {
    return new Promise((resolve, reject): void => {
      const parameters: string = `?locale=${user.getLocale()}&country=${user.getB2XCountryCode()}`
        + `&distribution_partner_number=${user.getBusinessPartner()?.getDistributionPartnerNumber()}`
        + `&outlet_number=${user.getBusinessPartner()?.getOutletNumber()}`;
      this.httpClient.get('/api/typecode/v1/' + typeCode + parameters, {withCredentials: true})
        .subscribe({
          next: (vehicle: IVehicleTypeInformation): void => resolve(CosyService.addBasePathToCosyUrls(
            Vehicle.createVirtualVehicle(vehicle)
          )),
          error: (reason: any): void => reject(reason)
        });
    });
  }
}
